













import { Prop, Component, Vue } from 'vue-property-decorator';
import ToggleSwitch from '@/components/UiComponents/ToggleSwitch.vue';
import * as $ from 'jquery';
@Component({components: {ToggleSwitch} })
export default class InplaceSendingOptions extends Vue {
    @Prop() signProp?: boolean;
    @Prop() setCopyProp?: boolean;
    sign = false;
    setCopy = false;
   
    toggle(mode: string){
        if(mode == 'setCopy')this.setCopy = !this.setCopy;
        if(mode=='sign') this.sign = !this.sign;
        const options = {sign: this.sign, setCopy: this.setCopy};
        this.$emit('toggle-options',options);
    }
   

    created(){
        if(this.signProp) this.sign = this.signProp;
        if(this.setCopyProp) this.setCopy = this.setCopyProp;
    }

    close(){
        this.$emit('close');
    }
}
